import script from "./WithdrawalTokenSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawalTokenSelect.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawalTokenSelect.vue?vue&type=style&index=0&id=50ef8a00&scoped=true&lang=css"
script.__scopeId = "data-v-50ef8a00"

export default script